import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DotMenu, { Options } from '../primitives/dotMenu/DotMenu';
import { MenuConstants } from '../../constants/MenuConstants';
import ActionDropdown from '../primitives/dropdowns/ActionDropdown';

interface TemplateMenuProps {
  className?: string;
  iconSize?: string;
  dropdownMenu?: boolean;
  onOptionClick?: Function;
  disabled?: boolean;
}

const TemplateMenu: React.FC<TemplateMenuProps> = ({
  iconSize = '',
  className = '',
  dropdownMenu = false,
  onOptionClick,
  disabled = false
}) => {
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState<Options | null>();
  const { t } = useTranslation();

  useEffect(() => {
    if (selectedOption) {
      switch (selectedOption.key) {
        case MenuConstants.TEMPLATE_MENU_COPY:
          if (onOptionClick) {
            onOptionClick(MenuConstants.TEMPLATE_MENU_COPY);
          }
          break;
        case MenuConstants.TEMPLATE_EDIT:
          if (onOptionClick) {
            onOptionClick(MenuConstants.TEMPLATE_EDIT);
          }
          break;
      }
    }
  }, [selectedOption]);

  const dotMenuOptions: Array<any> = [
    {
      display: `${t('T_EDIT_TEMPLATE')}`,
      key: MenuConstants.TEMPLATE_EDIT
    },
    {
      display: `${t('T_TEMPLATE_COPY')}`,
      key: MenuConstants.TEMPLATE_MENU_COPY
    }
  ];

  return (
    <>
      {dropdownMenu ? (
        <ActionDropdown
          className={disabled ? 'disabled' : ''}
          options={dotMenuOptions}
          onSelectedOptionChange={(value: any) => {
            setSelectedOption(value);
          }}
          value={t('T_MANAGE_TEMPLATE')}
          defaultLabel={t('T_MANAGE_TEMPLATE')}
        />
      ) : (
        <DotMenu
          options={dotMenuOptions}
          onSelectedOptionChange={(value) => {
            setSelectedOption(value);
          }}
          value={selectedOption}
        />
      )}
    </>
  );
};

export default TemplateMenu;
